import { render, staticRenderFns } from "./priceVariations.vue?vue&type=template&id=49970de4&scoped=true&lang=pug"
import script from "./priceVariations.vue?vue&type=script&lang=js"
export * from "./priceVariations.vue?vue&type=script&lang=js"
import style0 from "./priceVariations.vue?vue&type=style&index=0&id=49970de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49970de4",
  null
  
)

export default component.exports